import {CountryDomainModel} from "../../../common/country/models/country-domain-model";
import {GameCompetitorApiModel} from "./game-competitor-api-model";
import {LineupsDomainModel} from "../../../yard/lineups/lineups-domain-model";
import {SportDomainModel} from "../../../sports/models/sport-domain-model";
import {CompetitorDomainModel} from "../../../common/competitor/models/competitor-domain-model";
import {PartialGameDomainModel} from "../partial-game-domain-model";
import {RankingsDomainModel} from "../../../yard/rankings/rankings.domain-model";
import {RecordDomainModel} from "../record/record.domain-model";
import {FoulsDomainModel} from "../fouls/fouls.domain-model";
import {runInAction, action, observable, computed, makeObservable} from 'mobx';

export class GameCompetitorDomainModel extends CompetitorDomainModel {
  @observable lineups: LineupsDomainModel = null;
  rankings: Array<RankingsDomainModel> = [];
  @observable fouls: FoulsDomainModel;
  record: RecordDomainModel;
  @observable score: Number;
  aggregatedScore: Number;
  @observable seriesScore: Number;
  @observable isQualified: String;
  @observable toQualify: String;
  @observable isWinner: String;
  @observable redCards: String;
  type: String;
  recentMatches: Array<PartialGameDomainModel>;
  extraDataTitle: String;
  competitorNum: Number;

  constructor(
    apiModel: GameCompetitorApiModel,
    country: CountryDomainModel,
    sport: SportDomainModel,
    lineups: LineupsDomainModel,
    rankings: Array<RankingsDomainModel>,
  ) {
    super(apiModel, country, sport);

    this.lineups = lineups;
    this.rankings = rankings;
    this.record = apiModel.fouls && new FoulsDomainModel(apiModel.fouls);
    this.fouls = apiModel.fouls && new FoulsDomainModel(apiModel.fouls);
    this.score = apiModel.score;
    this.record = apiModel.record;
    this.aggregatedScore = apiModel.aggregatedScore;
    this.seriesScore = apiModel.seriesScore;
    this.isQualified = apiModel.isQualified;
    this.toQualify = apiModel.toQualify;
    this.isWinner = apiModel.isWinner;
    this.redCards = apiModel.redCards;
    this.type = apiModel.type;
    this.recentMatches = apiModel.recentMatches;
    this.extraDataTitle = apiModel.extraDataTitle;
    this.symbolicName = apiModel.symbolicName;
    this.competitorNum = apiModel.competitorNum;
    this.inPossession = apiModel.inPossession;

    makeObservable(this);
  }

  @computed get hasScore(): Boolean {
    return this.score !== -1;
  }

  @computed get penaltyScore(): Number {
    return this.apiModel.penaltyScore;
  }

  @action update(model: GameCompetitorDomainModel) {
    super.update(model);

    runInAction(() => {
      this.lineups = model.lineups;
      this.rankings = model.rankings;
      this.record = model.fouls && new FoulsDomainModel(model.fouls);
      this.fouls = model.fouls && new FoulsDomainModel(model.fouls);
      this.score = model.score;
      this.record = model.record;
      this.score = model.score;
      this.aggregatedScore = model.aggregatedScore;
      this.seriesScore = model.seriesScore;
      this.isQualified = model.isQualified;
      this.toQualify = model.toQualify;
      this.isWinner = model.isWinner;
      this.redCards = model.redCards;
      this.type = model.type;
      this.recentMatches = model.recentMatches;
      this.extraDataTitle = model.extraDataTitle;
      this.symbolicName = model.symbolicName;
      this.competitorNum = model.competitorNum;
      this.inPossession = model.inPossession;
    })

  }

}
